import { Insight } from '@toggle/toggle';

import {
  getFilteredInsights,
  GetFilteredInsightsProps,
} from '~/api/insights/insights-service';

import { create } from '../create-store/createStore';

type InsightStore = {
  insights: Insight[];
  error: boolean;
  loading: boolean;
  getInsights: (props: GetFilteredInsightsProps) => Promise<void>;
  getInsight: (id: string) => Insight | undefined;
  getInsightsForEntity: (tag: string) => Insight[];
};

export const useInsights = create<InsightStore>((set, get) => ({
  insights: [],
  error: false,
  loading: false,
  getInsights: async (props: GetFilteredInsightsProps) => {
    set({ loading: true });
    const res = await getFilteredInsights(props);
    if (res.data) {
      set({ insights: res.data.result, loading: false, error: false });
    } else {
      set({ insights: [], loading: false, error: true });
    }
  },
  getInsight: id => get().insights.find(i => i.id === id),
  getInsightsForEntity: tag =>
    get().insights.filter(i => i.metadata.entity == tag),
}));
